/**
 * Created by vladislav on 06.07.2021
 */

cleverapps.UI.LabelTTF = cc.LabelTTF.extend({
    ctor: function (text, font, wrapWidth) {
        this._wrapWidth = 0;
        this._strokeOpacity = 0;
        this._isRTL = false;
        this._super("", font);

        this.setWrapWidth(wrapWidth);

        if (cleverapps.UI.isRTL()) {
            this._isRTL = true;
            this.setHorizontalAlignment(cc.TEXT_ALIGNMENT_RIGHT);
        }

        this._fontScale = ["ja", "zh", "ko"].includes(cleverapps.settings.language) && cleverapps.styles.UI.glyphScale
            ? (cleverapps.styles.UI.glyphScale.scale || 1) : 1;
    },

    fitTo: function (maxWidth, maxHeight) {
        this.fitToSize = {
            width: maxWidth,
            height: maxHeight
        };

        cleverapps.UI.ImageFont.prototype.fitTo.call(this, maxWidth, maxHeight);

        this.debugRegionForFitTo = { width: maxWidth, height: maxHeight };
    },

    splitInHalf: function (maxWidth) {
        if (this.width > maxWidth) {
            const text = this.getString();
            const mid = text.length / 2;

            const closest = (left, right) => (right === -1 || (left !== -1 && mid - left < right - mid) ? left : right);

            const spacePos = closest(text.lastIndexOf(" ", mid), text.indexOf(" ", mid));
            const hyphenPos = closest(text.lastIndexOf("-", mid), text.indexOf("-", mid));

            if (spacePos === -1 && hyphenPos === -1) {
                return;
            }

            const useHyphen = hyphenPos !== -1
                && (spacePos === -1 || Math.abs(mid - (hyphenPos + 1)) < Math.abs(mid - spacePos));

            if (useHyphen) {
                this.setString(`${text.slice(0, hyphenPos + 1)}\n${text.slice(hyphenPos + 1)}`);
            } else {
                this.setString(`${text.slice(0, spacePos)}\n${text.slice(spacePos + 1)}`);
            }
        }
    },

    canAttachLastLine: function () {
        const strings = this._renderCmd._strings;
        if (!strings || strings.length <= 1 || this._doNotAttachLastLine || this._byLetterAnimationRunning) {
            return false;
        }

        const last = strings[strings.length - 1];
        if (this._string.slice(this._string.length - last.length - 1) === `\n${last}`) {
            return false;
        }

        return strings[strings.length - 2].length >= 10 && last.length <= 2;
    },

    setWrapWidth: function (width) {
        if (width > 0) {
            width = Math.min(width, this.maxWidth());
        } else {
            width = Math.min(cleverapps.styles.UI.TTFText.wrapWidth, this.maxWidth());
        }

        if (this._wrapWidth !== width) {
            this._wrapWidth = width;

            const oldString = this.getString();
            cc.LabelTTF.prototype.setString.call(this, "");
            cc.LabelTTF.prototype.setString.call(this, oldString);
        }
    },

    setFontSize: function (fontSize) {
        if (this._fontScale !== 1) {
            fontSize = Math.round(fontSize * this._fontScale);
        }

        this._super(fontSize);
    },

    getFontSize: function () {
        let fontSize = this._super();

        if (this._fontScale !== 1) {
            fontSize = Math.round(fontSize / this._fontScale);
        }

        return fontSize;
    },

    setFont: function (font) {
        this.setFontFillColor(font.color || cleverapps.styles.COLORS.WHITE);
        this.setFontSize(font.size);
        this._originalFontSize = font.size;

        if (font.shadow) {
            this.enableShadow(font.shadow.color, font.shadow.direction, font.shadow.blur);
        } else {
            this.disableShadow();
        }

        if (font.stroke) {
            this.enableStroke(font.stroke.color, font.stroke.size);
        } else {
            this.disableStroke();
        }

        if (font.lineHeight) {
            this.setLineHeight(font.lineHeight);
        }

        const oldString = this.getString();
        cc.LabelTTF.prototype.setString.call(this, "");
        cc.LabelTTF.prototype.setString.call(this, oldString);
    },

    enableStroke: function (strokeColor, strokeSize) {
        this._super(strokeColor, strokeSize);

        const strokeOpacity = strokeColor.a / 255;

        if (this._strokeOpacity !== strokeOpacity) {
            this._strokeOpacity = strokeOpacity;
            this._renderCmd._setColorsString();
        }
    },

    byLetterAnimation: function (options) {
        options = options || {};
        const oneLetterDelay = options.speed || 0.03;
        const firstLetterDelay = options.delay || 0.1;

        let string = this.getString();

        cc.LabelTTF.prototype.setString.call(this, "");

        for (let wordStart = 0, wordEnd = 0, height = this.height; wordEnd <= string.length; ++wordEnd) {
            if (wordEnd === string.length || string[wordEnd] === " " || string[wordEnd] === "\n") {
                this._doNotAttachLastLine = wordEnd !== string.length;

                cc.LabelTTF.prototype.setString.call(this, string.substring(0, wordEnd));

                if (this.height !== height) {
                    if (wordStart !== 0) {
                        string = `${string.substring(0, wordStart)}\n${string.substring(wordStart + 1)}`;
                    }

                    height = this.height;
                }

                wordStart = wordEnd;
            }
        }

        if (this._byLetterAnimationRunning) {
            this.stopAllActions();
        }
        this._byLetterAnimationRunning = true;
        this._byLetterAnimationDone = function (skipped) {
            if (this._byLetterAnimationRunning) {
                this.stopAllActions();
                this._byLetterAnimationRunning = false;
                cc.LabelTTF.prototype.setString.call(this, string);
                this._byLetterAnimationDone = undefined;
                if (options.callback) {
                    options.callback(skipped);
                }
            }
        }.bind(this);

        let amountLetters = Math.min(options.startFrom || 0, string.length);
        cc.LabelTTF.prototype.setString.call(this, string.substr(0, amountLetters));

        const addOneLetter = function (delay) {
            this.runAction(new cc.Sequence(new cc.DelayTime(delay), new cc.CallFunc(() => {
                amountLetters++;
                cc.LabelTTF.prototype.setString.call(this, string.substr(0, amountLetters));
                if (amountLetters < string.length) {
                    addOneLetter(oneLetterDelay);
                } else if (this._byLetterAnimationDone) {
                    this._byLetterAnimationDone();
                }
            })));
        }.bind(this);

        addOneLetter(firstLetterDelay);
    },

    byLetterAnimationFinish: function () {
        if (this._byLetterAnimationRunning) {
            this._byLetterAnimationDone(true);
        }
    },

    setString: function (text) {
        this._setString(text);
    },

    _setString: function (string) {
        string = `${typeof string === "number" ? string : string || ""}`;

        cc.LabelTTF.prototype.setString.call(this, string);

        if (this.fitToSize) {
            cleverapps.UI.ImageFont.prototype.fitTo.call(this, this.fitToSize.width, this.fitToSize.height);
        }
    },

    maxWidth: function () {
        if (cc._renderType === cc.game.RENDER_TYPE_CANVAS) {
            return cleverapps.styles.UI.TTFText.wrapWidth;
        }
        return this._super();
    },

    minFontSize: function () {
        return (connector.info.isMobile ? 8 : 5) * resolutionScale;
    },

    visitTextureBundle: function () {
        cc.rendererBundle = "LabelTTF";
    }
});

(function () {
    cc.LabelTTF.METRICS_STRING = "|ÉÅÇعر";
    cc.LabelTTF.BASELINE_SYMBOL = "M";
    cc.LabelTTF.__labelPropertiesCanvas = document.createElement("canvas");
    cc.LabelTTF.__labelPropertiesContext = cc.LabelTTF.__labelPropertiesCanvas.getContext("2d");
    cc.LabelTTF.__fontPropertiesCache = {};

    cc.LabelTTF.__fallbackFontProperties = function (fontSize) {
        return {
            ascent: Math.round((fontSize || 0) * 1.06),
            descent: Math.round((fontSize || 0) * 0.3)
        };
    };

    // Old embedded Chrome builds occasionally throw "Illegal invocation" from the shared measurement
    // context; a label must still be created, otherwise the focus that opens it is never released.
    cc.LabelTTF.__getFontProperties = function (fontName, fontSize) {
        try {
            return cc.LabelTTF.__measureFontProperties(fontName, fontSize);
        } catch (e) {
            if (!cc.LabelTTF.__fontPropertiesFailureReported) {
                cc.LabelTTF.__fontPropertiesFailureReported = true;
                cleverapps.throwAsync(`__getFontProperties failed for ${fontName} ${fontSize}: ${e && e.message}`);
            }
            return cc.LabelTTF.__fallbackFontProperties(fontSize);
        }
    };

    cc.LabelTTF.__measureFontProperties = function (fontName, fontSize) {
        let key, fontStyleStr;

        if (fontSize === undefined) {
            key = fontName;
            fontStyleStr = fontName;
        } else {
            key = `${fontName}.${fontSize}`;
            fontStyleStr = `${fontSize}px '${fontName}'`;
        }

        let properties = cc.LabelTTF.__fontPropertiesCache[key];
        if (properties) {
            return properties;
        }

        properties = {
            ascent: 0,
            descent: 0
        };

        const canvas = cc.LabelTTF.__labelPropertiesCanvas;
        const context = cc.LabelTTF.__labelPropertiesContext;
        context.font = fontStyleStr;

        const text = cc.LabelTTF.METRICS_STRING + cc.LabelTTF.BASELINE_SYMBOL;
        const textMetrics = context.measureText(text);

        if (textMetrics.actualBoundingBoxAscent && textMetrics.actualBoundingBoxDescent) {
            cc.LabelTTF.__fontPropertiesCache[key] = properties = {
                ascent: textMetrics.actualBoundingBoxAscent,
                descent: textMetrics.actualBoundingBoxDescent
            };
            return properties;
        }

        const canvasWidth = Math.ceil(textMetrics.width);
        const symbolMetrics = context.measureText(cc.LabelTTF.BASELINE_SYMBOL);
        const canvasHeight = Math.ceil(2 * symbolMetrics.width);
        const baseline = Math.ceil(1.4 * symbolMetrics.width);

        if (!canvasWidth || !canvasHeight) {
            return cc.LabelTTF.__fallbackFontProperties(fontSize);
        }

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        context.fillStyle = "#f00";
        context.fillRect(0, 0, canvasWidth, canvasHeight);

        context.font = fontStyleStr;

        context.textBaseline = "alphabetic";
        context.fillStyle = "#000";
        context.fillText(text, 0, baseline);

        const imagedata = context.getImageData(0, 0, canvasWidth, canvasHeight).data;
        const line = canvasWidth * 4;

        let idx = 0;
        let stop = false;
        let i, j;

        for (i = 0; i < baseline; ++i) {
            for (j = 0; j < line; j += 4) {
                if (imagedata[idx + j] !== 255) {
                    stop = true;
                    break;
                }
            }
            if (stop) {
                break;
            }
            idx += line;
        }
        properties.ascent = baseline - i;

        idx = imagedata.length - line;
        stop = false;

        for (i = canvasHeight; i > baseline; --i) {
            for (j = 0; j < line; j += 4) {
                if (imagedata[idx + j] !== 255) {
                    stop = true;
                    break;
                }
            }
            if (stop) {
                break;
            }
            idx -= line;
        }
        properties.descent = i - baseline;

        cc.LabelTTF.__fontPropertiesCache[key] = properties;
        return properties;
    };
}());

cleverapps.overrideStyles(cleverapps.styles.UI, {
    TTFText: {
        wrapWidth: 1300
    }
});
